<template>
    <div class="table-responsive mb-0">
        <table class="table table-sm table-bordered">
            <thead>
                <tr>
                    <th class="w-50">İşlem Türü</th>
                    <th class="w-50">Tarih</th>
                    <th>İndir</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(prc,index) in value" :key="index">
                    <td>{{$safe(prc,'ProcessStatus.Name') || '-'}}</td>
                    <td>{{getTime($safe(prc,'CreateTime')) || '-'}}</td>
                    <td>
                        <button :disabled="loading" class="btn btn-primary btn-sm d-flex align-items-center" v-on:click="download(prc,index)">
                            <b-spinner small v-if="currentIndex == index && loading"></b-spinner>
                            <feather-icon icon="DownloadIcon" v-else></feather-icon>
                            <span class="ml-50">İndir</span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table> 
    </div>
</template>

<script>
import moment from 'moment'
import {BSpinner} from 'bootstrap-vue'
import Additional from '@/utilities/additional'
export default {
    components:{
        BSpinner
    },
    props:{
        value:Array
    },
    data(){
        return{
            loading:false,
            currentIndex:0
        }
    },
    methods:{
        getTime(time){
            return moment(time).locale('tr').format('DD.MM.YYYY HH:mm')
        },
        download(prc,index){
            this.currentIndex = 0
            this.loading = true
            this.currentIndex = index
            Additional.GetBlobFile(prc.FileEntity.FilePath + prc.FileEntity.FileExtension).then(blob=>{
                Additional.DownloadFile(blob.data,prc.FileEntity.FileName + prc.FileEntity.FileExtension)
                this.loading = false
            }).catch(err=>{
                this.loading = false
            })
        }
    }
}
</script>

<style>

</style>